<template>
  <section >
    <h2 class="titulo-links-escolha">CADASTRAR SEGMENTO ESCOLAR</h2> 
    <div class="form-elements">
      <div class="row">
        <div class="flex xs12">
          <va-card :title="$t('forms.inputs.title')">
            <va-card-content>
              <form>
                <div class="row">
                  <div class="flex md4 sm6 xs12">
                    <va-input
                      v-model="segmentoEscolar.nome"
                      :label="$t('Segmento')"
                    />
                  </div>
                  <div class="flex">
                    <va-button class="mr-2 mb-2"  @click="cadastrar"> {{ $t('Cadastrar') }}</va-button>  
                  </div>
                </div>
              </form>
            </va-card-content>
          </va-card>
        </div>
      </div>
    </div>
  </section >
</template>

<script>

import { SegmentoEscolar } from "@/class/segmentoEscolar.js";
import vueMask from 'vue-jquery-mask';
import store_token_info from "@/store/store_token_info.js";


export default {
  props: {
    id:{
    },
  },
  components: {
   
  },
  name: 'Segmento-Escolar',
  data () {
    return {
      segmentoEscolar: {
        nome:null,
        user_id: store_token_info.usuario_logado,
      },
    }
  },
  methods: {
    async cadastrar() {
      try {
        const data = await SegmentoEscolar.cadastrar(this.segmentoEscolar);
        this.$vaToast.init({
          message: "Cadastrado com sucesso!",
          iconClass: 'fa-star-o',
          position: 'top-right',
          duration: 2500,
          fullWidth: false,
        })
      }
      catch(e) {
        alert(e);
        this.$vaToast.init({
          message: "Erro ao cadastrar!",
          iconClass: 'fa-star-o',
          position: 'top-right',
          duration: 2500,
          fullWidth: false,
        })
      }
    },
  },
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }

  .form-control:focus {
    background-color: #f6f7f6;
    border-color: #673ab7;
    box-shadow: none;
  }
  .form-control {
    background-color: #f6f7f6;
    border: 1px solid #f6f6f6;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
     margin: 0;
  }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }


  .va-input-wrapper, fieldset {
    margin-bottom: 0.5rem;
  }
</style>
